module.exports = __webpack_public_path__ + "static/media/trophy.ef6a4795.svg";